import{isFunction as t}from"../../../utils/dist/is-function.es.js";function i(i,n,o){return t(i)?i(n,o):i}export{i as resolveOption};
